import React from 'react';
import { PrismicLink } from 'components/PrismicLink';
import { LrButton } from 'components/LANDR/LrButton';

const GO_TO_APP_LINK = { url: process.env.GATSBY_APP_ENDPOINT };

const SignUpOrGoToApp = ({
    label,
    link,
    className,
    isButton,
    isLoggedIn,
    goToAppLabel,
}: {
    label: string;
    link: any;
    className: string;
    isButton: boolean;
    isLoggedIn: boolean;
    goToAppLabel: string;
}) =>
    isButton ? (
        <PrismicLink className={className} link={isLoggedIn ? GO_TO_APP_LINK : link}>
            <LrButton variant={'primary'} size="xsmall">
                {isLoggedIn ? goToAppLabel : label}
            </LrButton>
        </PrismicLink>
    ) : (
        <PrismicLink
            className={className}
            label={isLoggedIn ? goToAppLabel : label}
            link={isLoggedIn ? GO_TO_APP_LINK : link}
        />
    );

export default SignUpOrGoToApp;
